/**
 * Global Cart UI Components: Sticky Cart Pill & Mobile Bottom Nav & Card Qty Sync
 */

(function() {
  const MAX_THUMBS = 3;

  function initCartUI() {
    const stickyPill = document.getElementById('sticky-cart-pill');
    const pillThumbs = document.getElementById('sticky-pill-thumbs');
    const pillItems = document.getElementById('sticky-pill-items');
    const pillTotal = document.getElementById('sticky-pill-total');
    const mobCartBadge = document.getElementById('mob-cart-badge');

    // ── Cart UI helpers (Product Cards) ──────────────────────────
    function showQtySelector(toggle, qty) {
      // Supports both <product-form> and plain <div> wrappers for the add button
      const addWrapper = toggle.querySelector('product-form') || toggle.querySelector(':scope > div:first-child');
      const qtySelector = toggle.querySelector('.quantity-selector-custom');
      const qtyCount = toggle.querySelector('.qty-count');
      if (addWrapper) addWrapper.classList.add('hidden');
      if (qtySelector) qtySelector.classList.remove('hidden');
      if (qtyCount) qtyCount.textContent = qty;
    }

    function showAddToCart(toggle) {
      // Supports both <product-form> and plain <div> wrappers for the add button
      const addWrapper = toggle.querySelector('product-form') || toggle.querySelector(':scope > div:first-child');
      const qtySelector = toggle.querySelector('.quantity-selector-custom');
      if (addWrapper) addWrapper.classList.remove('hidden');
      if (qtySelector) qtySelector.classList.add('hidden');
    }

    function showQtySpinners(variantId) {
      document.querySelectorAll(`.custom-cart-toggle[data-variant-id="${variantId}"]`).forEach(toggle => {
        toggle.classList.add('loading');
        // Inline spinner: hide count, show spinner, dim buttons
        const qtyCount = toggle.querySelector('.qty-count');
        const spinInline = toggle.querySelector('.qty-spin-inline');
        const minusBtn = toggle.querySelector('.qty-btn.minus');
        const plusBtn = toggle.querySelector('.qty-btn.plus');
        if (qtyCount) qtyCount.style.display = 'none';
        if (spinInline) spinInline.classList.add('active');
        if (minusBtn) { minusBtn.style.opacity = '0.4'; minusBtn.style.pointerEvents = 'none'; }
        if (plusBtn) { plusBtn.style.opacity = '0.4'; plusBtn.style.pointerEvents = 'none'; }
      });
    }

    function hideQtySpinners(variantId) {
      document.querySelectorAll(`.custom-cart-toggle[data-variant-id="${variantId}"]`).forEach(toggle => {
        toggle.classList.remove('loading');
        // Restore inline UI
        const qtyCount = toggle.querySelector('.qty-count');
        const spinInline = toggle.querySelector('.qty-spin-inline');
        const minusBtn = toggle.querySelector('.qty-btn.minus');
        const plusBtn = toggle.querySelector('.qty-btn.plus');
        if (qtyCount) qtyCount.style.display = '';
        if (spinInline) spinInline.classList.remove('active');
        if (minusBtn) { minusBtn.style.opacity = ''; minusBtn.style.pointerEvents = ''; }
        if (plusBtn) { plusBtn.style.opacity = ''; plusBtn.style.pointerEvents = ''; }
      });
    }

    function updateCartUI(variantId, quantity) {
      const vIdStr = String(variantId);
      document.querySelectorAll(`.custom-cart-toggle[data-variant-id="${vIdStr}"]`).forEach((toggle) => {
        // Only update if not currently loading to prevent flickering during rapid clicks
        if (!toggle.classList.contains('loading')) {
          if (quantity > 0) showQtySelector(toggle, quantity);
          else showAddToCart(toggle);
        }
      });
    }

    // ── Sticky Pill & Badge Logic ─────────────────────────────────
    async function updateStickyPill() {
      if (!stickyPill) return;
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();
        const count = cart.item_count || 0;
        const total = cart.total_price || 0;

        if (pillItems) pillItems.textContent = count + (count === 1 ? ' item' : ' items');
        if (pillTotal) pillTotal.textContent = '\u20B9' + (total / 100).toLocaleString('en-IN');

        if (mobCartBadge) {
          mobCartBadge.textContent = count;
          count > 0 ? mobCartBadge.classList.add('has-items') : mobCartBadge.classList.remove('has-items');
        }

        if (pillThumbs) {
          pillThumbs.innerHTML = '';
          const visible = (cart.items || []).slice(0, MAX_THUMBS);
          const extra = (cart.items || []).length - MAX_THUMBS;

          visible.forEach((item) => {
            if (item.image) {
              const img = document.createElement('img');
              img.src = item.image.replace(/\.(jpg|png|webp)(\?.*)?$/, '_60x60.$1$2');
              img.alt = item.title;
              img.className = 'sticky-pill-thumb';
              pillThumbs.appendChild(img);
            }
          });

          if (extra > 0) {
            const badge = document.createElement('div');
            badge.id = 'sticky-pill-extra';
            badge.textContent = '+' + extra;
            pillThumbs.appendChild(badge);
          }
          const lastChild = pillThumbs.lastElementChild;
          if (lastChild) lastChild.style.marginRight = '0';
        }

        count > 0 ? stickyPill.classList.add('visible') : stickyPill.classList.remove('visible');
      } catch (e) { /* silent */ }
    }

    // ── Full Cart Sync ──────────────────────────────────────────
    async function syncCart() {
      try {
        const cart = await fetch('/cart.js').then((r) => r.json());
        // Apply live quantities to all toggles that aren't currently "busy"
        document.querySelectorAll('.custom-cart-toggle').forEach((toggle) => {
          if (toggle.classList.contains('loading')) return;
          
          const vId = toggle.dataset.variantId;
          const item = (cart.items || []).find(i => String(i.variant_id) === String(vId));
          const qty = item ? item.quantity : 0;
          
          if (qty > 0) showQtySelector(toggle, qty);
          else showAddToCart(toggle);
        });
        updateStickyPill();
      } catch (e) { console.error('Cart sync failed:', e); }
    }

    window.syncCart = syncCart;
    window.updateStickyPill = updateStickyPill;

    // ── Cart Drawer Refresh ─────────────────────────────────────
    async function refreshCartDrawer() {
      try {
        const res = await fetch('/cart?section_id=cart-drawer');
        const text = await res.text();
        const doc = new DOMParser().parseFromString(text, 'text/html');
        ['cart-drawer-items', '.cart-drawer__footer'].forEach((sel) => {
          const newEl = doc.querySelector(sel);
          const el = document.querySelector(sel);
          if (newEl && el) el.innerHTML = newEl.innerHTML;
        });
        const drawer = document.querySelector('cart-drawer');
        const isEmpty = doc.querySelector('cart-drawer')?.classList.contains('is-empty');
        if (drawer) drawer.classList.toggle('is-empty', !!isEmpty);
      } catch (e) { /* silent */ }
    }

    window.openStickyCartDrawer = function() {
      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
        return;
      }
      const cartBtn = document.querySelector('#cart-icon-bubble, .header__icon--cart');
      if (cartBtn) {
        cartBtn.click();
        return;
      }
      window.location.href = '/cart';
    };

    // ── Quantity Change Handler ─────────────────────────────────
    let _suppressSync = false; // Prevents fetch interceptor from racing with handleQtyChange

    async function handleQtyChange(variantId, newQty) {
      // 1. Show loaders
      showQtySpinners(variantId);
      _suppressSync = true;
      
      try {
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: newQty }),
        });
        const cart = await response.json();
        
        // Parallel: refresh components
        await Promise.all([refreshCartDrawer(), updateStickyPill()]);
        
        // 2. Hide loaders and THEN update UI state
        hideQtySpinners(variantId);
        
        // Final UI update for this specific variant
        document.querySelectorAll(`.custom-cart-toggle[data-variant-id="${variantId}"]`).forEach(toggle => {
          if (newQty > 0) showQtySelector(toggle, newQty);
          else showAddToCart(toggle);
        });

      } catch (err) {
        console.error('Qty update failed:', err);
        hideQtySpinners(variantId);
        await syncCart();
      } finally {
        // Clear suppress flag after a short delay to avoid interceptor race
        setTimeout(() => { _suppressSync = false; }, 500);
      }
    }

    // Event Delegation for Plus/Minus Buttons
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.qty-btn');
      if (!btn) return;
      
      const toggle = btn.closest('.custom-cart-toggle');
      if (!toggle) return;
      if (toggle.classList.contains('loading')) return; // Prevent double clicks

      const variantId = toggle.dataset.variantId;
      const countEl = toggle.querySelector('.qty-count');
      const current = parseInt(countEl?.textContent || '0');
      const isPlus = btn.classList.contains('plus');
      const newQty = isPlus ? current + 1 : Math.max(0, current - 1);

      handleQtyChange(variantId, newQty);
    });

    // ── Hook into all fetch calls (Catch /cart/add etc.) ─────────
    const _origFetch = window.fetch;
    window.fetch = async function(...args) {
      const res = await _origFetch(...args);
      const url = args[0] instanceof Request ? args[0].url : String(args[0] || '');
      
      if (
        url.includes('/cart/add') ||
        url.includes('/cart/change') ||
        url.includes('/cart/update') ||
        url.includes('/cart/clear')
      ) {
        // Skip if handleQtyChange is managing its own update
        if (!_suppressSync) {
          const delay = url.includes('/cart/add') ? 400 : 300;
          setTimeout(syncCart, delay);
        }
      }
      return res;
    };

    // Initial load
    syncCart();
    window.addEventListener('focus', syncCart);
  }

  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartUI);
  } else {
    initCartUI();
  }
})();
